import { z } from 'zod';

export const CreatePaymentIntentInputSchema = z.object({
  bookingId: z.string().uuid().optional(),
  bookingGroupId: z.string().uuid().optional(),
  savePaymentMethod: z.boolean().optional().default(false),
}).refine((value) => Boolean(value.bookingId) !== Boolean(value.bookingGroupId), {
  message: 'Provide either bookingId or bookingGroupId',
});

export type CreatePaymentIntentInput = z.infer<typeof CreatePaymentIntentInputSchema>;
